<div
  class="cv-page cv-b"
  [ngClass]="{ 'thumbnail-view': isThumbnail }"
>
  <div class="cv-frame">
    <!-- LEFT (main) -->
    <main class="left-col">
      <header class="top">
        <div class="name">
          <div class="first-name">{{ data.firstName }} {{ data.lastName }}</div>
        </div>
        <div
          class="title"
          *ngIf="data.designation"
        >
          {{ data.designation }}
        </div>

        <div class="contact-row">
          <span
            *ngIf="data.contactDetails?.number"
            class="contact-item"
            >📞 {{ data.contactDetails.number }}</span
          >
          <span
            *ngIf="data.contactDetails?.email"
            class="contact-item"
            >✉ {{ data.contactDetails.email }}</span
          >
          <span
            *ngIf="data.contactDetails?.address"
            class="contact-item"
            >📍 {{ data.contactDetails.address || data?.city }}</span
          >
          <span
            *ngIf="data.contactDetails?.linkedIn"
            class="contact-item"
            >in {{ data.contactDetails.linkedIn }}</span
          >
        </div>
      </header>

      <section
        class="objective"
        *ngIf="data.about"
      >
        <h4 class="section-label green">OBJECTIVE</h4>
        <p class="objective-text">{{ data.about }}</p>
      </section>

      <section class="experience">
        <h4 class="section-label green">EXPERIENCE</h4>

        <!-- groupedExperience is computed in the component TS -->
        <div
          class="exp-group"
          *ngFor="let g of groupedExperience"
        >
          <div class="group-title">{{ g.name }}</div>

          <div
            class="role"
            *ngFor="let item of g.items"
          >
            <!-- role heading (e.g. VIOLIN SECTION LEADER) -->
            <div
              class="role-title"
              *ngIf="item.Title"
            >
              {{ item.Title }}
            </div>

            <!-- main line: bullet + years + | + company + location -->
            <p class="role-line">
              <span class="bullet">●</span>
              <strong class="years"
                >{{ item.startDate
                }}{{
                  item.endDate ? ' - ' + item.endDate : ' - Present'
                }}</strong
              >
              <span class="company">{{ item.company }}</span>
              <span
                class="location"
                *ngIf="item.joblocation?.City || item.joblocation?.State"
              >
                <span class="sep">|</span>
                {{ item.joblocation?.City
                }}{{
                  item.joblocation?.State ? ', ' + item.joblocation.State : ''
                }}
              </span>
            </p>

            <!-- small description bullets (if any) -->
            <ul
              *ngIf="item.descriptionPoints?.length"
              class="mini-points"
            >
              <li *ngFor="let p of item.descriptionPoints">{{ p }}</li>
            </ul>
          </div>
        </div>
      </section>
    </main>

    <!-- RIGHT SIDEBAR (unchanged) -->
    <aside class="right-col">
      <section
        class="box education"
        *ngIf="data.educations?.length"
      >
        <h5>EDUCATION</h5>
        <div
          *ngFor="let e of data.educations"
          class="edu"
        >
          <div class="edu-degree">{{ e.courseName }}</div>
          <div class="edu-school">{{ e.universityName }}</div>
          <div class="edu-date">{{ e.formattedDate }}</div>
        </div>
      </section>

      <section
        class="box teachers"
        *ngIf="data.teachers?.length"
      >
        <h5>PRINCIPAL TEACHERS</h5>
        <ul>
          <li *ngFor="let t of data.teachers">{{ t }}</li>
        </ul>
      </section>

      <section
        class="box skills"
        *ngIf="data.skills?.length"
      >
        <h5>SKILLS</h5>
        <ul class="skills-list">
          <li *ngFor="let s of data.skills">{{ s }}</li>
        </ul>
      </section>

      <section
        class="box honors"
        *ngIf="data.honors?.length"
      >
        <h5>HONORS/AWARDS</h5>
        <ul>
          <li *ngFor="let h of data.honors">{{ h }}</li>
        </ul>
      </section>
    </aside>
  </div>
</div>
